import PageCommon from "./PageCommon.js";
import Pqp from "../3x1010/Pqp.js";
import Globals from "../Globals.js";
import Nav from "./components/Nav.js";
import WineFilters from "./components/WineFilters.js";
import {
  getQueryStringData,
  initExploreOnScroll
} from "../helpers/helpers.js";

export default class PageVini extends PageCommon {
  constructor() {
    super();
  }

  init($data) {
    super.init($data);
    this.data = $data;
    console.log(this.data);
    this.showPreloader(false);
    Pqp.trace("PageVini - Hello world");
    // console.log(TheApp.CurrentContext.IsAuthenticated);

    this.initBlocksOnScrollAnimations();
    this.initWineFiltersWidget();

    // dispaccio un evento globale
    try {
      this.dispatchInitEvent(TheDisp.EV_PAGETHIS_INITED);
    } catch (error) {
      console.log(error);
    }
  }

  get isHomepage() {
    return false;
  }

  initBlocksOnScrollAnimations() {
    initExploreOnScroll(this.page.querySelectorAll(".js-section-explore"));
  }

  initWineFiltersWidget() {
    const filterBar = this.page?.querySelector(".js-wine-filters");
    const filterBtn = filterBar?.querySelector(".js-btn-toggle-filters");
    const filterDialog = this.page?.querySelector(".js-dialog-filter");

    this.initStickyFilterBar(filterBar, Nav.Nav, Nav.navHeight);

    const filter = new WineFilters(
      this.page,
      filterBar,
      filterDialog,
      this.data
    );
    filter.init();

    filterBtn?.addEventListener(
      "click",
      (e) => filter.isOpen ? filter.close() : filter.open()
    );
  }

  /**
   * Sticky filterBar effect on scroll,
   * pushes navbar out of the viewport
   * */
  initStickyFilterBar(filterBar, navbar, navHeight) {
    let barY = filterBar?.offsetTop;
    let scrolled = false;
    let resizing;

    window.addEventListener("resize", (e) => {
      clearTimeout(resizing);
      resizing = setTimeout(() => {
        if (!scrolled) {
          barY = filterBar?.offsetTop;
        }
      }, 250);
    });

    window.addEventListener("scroll", e => {
      if (window.scrollY + navHeight > barY) {
        Nav.closeNav();

        const offset = window.scrollY - barY;
        navbar?.style.setProperty(
          "transform",
          `translate(-50%, ${Math.round((navHeight + offset) * -1) + 1}px)`
        );

      } else if (!scrolled) {
        navbar?.style.removeProperty("transform");
      }

      if (window.scrollY > barY) {       
        if (!scrolled) {
          scrolled = !scrolled;
          filterBar?.classList.add("is-sticky");
        }

      } else {
        if (scrolled) {
          scrolled = !scrolled;
          navbar?.style.removeProperty("transform");
          filterBar?.classList.remove("is-sticky");
        }
      }
    });
  }
}